import {
  FETCH_SPECIMEN_OPTIONS_REQUEST,
  FETCH_SPECIMEN_OPTIONS_SUCCESS,
  FETCH_SPECIMEN_OPTIONS_FAILURE,
  FETCH_SPECIMEN_OPTIONS_RESET,
  REQUEST_SPECIMEN_REQUEST,
  REQUEST_SPECIMEN_SUCCESS,
  REQUEST_SPECIMEN_RESET,
  REQUEST_SPECIMEN_FAILURE,
} from '../constants';

const initialState = {
  specimenRequest: false,
  specimenData: {},
  specimenStatus: false,
  specimenError: '',
};

interface stateType {
  specimenRequest: boolean;
  specimenData: any;
  specimenStatus: boolean;
  specimenError: string;
}

interface actionType {
  type: string;
  payload?: {
    data?: any;
    error?: string;
  };
}

export const specimenReducer = (state = initialState, action: actionType): stateType => {
  switch (action.type) {
    case FETCH_SPECIMEN_OPTIONS_REQUEST:
      return {
        ...state,
        specimenRequest: true,
        specimenData: {},
        specimenStatus: false,
        specimenError: '',
      };

    case FETCH_SPECIMEN_OPTIONS_SUCCESS:
      return {
        ...state,
        specimenRequest: false,
        specimenData: action.payload?.data || {},
        specimenStatus: true,
        specimenError: "",
      };

    case FETCH_SPECIMEN_OPTIONS_FAILURE:
      return {
        ...state,
        specimenRequest: false,
        specimenData: {},
        specimenStatus: false,
        specimenError: action.payload?.error || '',
      };

    case FETCH_SPECIMEN_OPTIONS_RESET:
      return initialState;

    default:
      return state;
  }
};

const requestSpecimenInitialState = {
  requestSpecimenRequest: false,
  requestSpecimenData: {},
  requestSpecimenStatus: false,
  requestSpecimenError: '',
};

interface requestSpecimenType {
  requestSpecimenRequest: boolean;
  requestSpecimenData: Record<string, any>;
  requestSpecimenStatus: boolean;
  requestSpecimenError: string;
}

export const requestSpecimenReducer = (
  state = requestSpecimenInitialState,
  action: actionType,
): requestSpecimenType => {
  switch (action.type) {
    case REQUEST_SPECIMEN_REQUEST:
      return {
        ...state,
        requestSpecimenRequest: true,
        requestSpecimenData: {},
        requestSpecimenStatus: false,
        requestSpecimenError: '',
      };
    case REQUEST_SPECIMEN_SUCCESS:
      return {
        ...state,
        requestSpecimenRequest: false,
        requestSpecimenData: action?.payload?.data || {},
        requestSpecimenStatus: true,
        requestSpecimenError: '',
      };
    case REQUEST_SPECIMEN_FAILURE:
      return {
        ...state,
        requestSpecimenRequest: false,
        requestSpecimenData: {},
        requestSpecimenStatus: false,
        requestSpecimenError: action?.payload?.error || 'Something went wrong!!!',
      };

    case REQUEST_SPECIMEN_RESET:
      return requestSpecimenInitialState;

    default:
      return state;
  }
};
